import { render, staticRenderFns } from "./modaldetailHistoryP2h.vue?vue&type=template&id=1b140afb&scoped=true"
import script from "./modaldetailHistoryP2h.vue?vue&type=script&lang=js"
export * from "./modaldetailHistoryP2h.vue?vue&type=script&lang=js"
import style0 from "./modaldetailHistoryP2h.vue?vue&type=style&index=0&id=1b140afb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b140afb",
  null
  
)

export default component.exports